export default "__VITE_ASSET__4fcebaf4__"